import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
    DateField,
    EditButton,
    ShowButton,
    ListButton,
    CardActions,
    TextInput,
    DateInput,
    Filter,
    SelectInput
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorBoundary from '../ErrorBoundary';


const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};



export const LogFilter = props => (
    <Filter {...props}>
        <TextInput source="ssn" alwaysOn  label='SSN'/>
        
        <TextInput source="ucn" label="UCN" />
        <DateInput source="bleed_date"    label="Bleed date" locales="en-us"/>
    </Filter>
);

export const Lookback = ({ classes, ...props }) => (
    <ErrorBoundary>  
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        filters={<LogFilter />}
        title="Lookback"
        >
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="ssn"     label="SSN" />  
            <TextField source="ucn"    label="UCN" />  
            <TextField source="comments" lable="Comments" />
            <DateField source="bleed_date"    label="Bleed date" locales="en-us"/>
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default withStyles(listStyles)(Lookback)